export default __webpack_public_path__ + "static/media/preview.Videos.152dbbd8.mp4";